<template>
  <v-app-bar
    app
    color="#151b1c"
    dark
    clipped-right
  >
    <router-link
      to="/" exact>     
      <v-toolbar-title to="/" exact>         
        Sample Chat
      </v-toolbar-title>
    </router-link>   
  
    <!-- ログイン時 -->
    <v-spacer></v-spacer>
    <div v-if="user.uid" key="login" class="navbar-item">
      <router-link
        to="/" exact>     
        <v-btn text color="white" @click="doLogout">
          ログアウト
        </v-btn>
      </router-link>
    </div>
    <v-app-bar-nav-icon v-if="user.uid" @click.stop="switchDrawer"></v-app-bar-nav-icon>
  </v-app-bar>
</template>
<script>
import Firebase from './../firebase'
import $ from 'jquery'

export default {
  components: {
  },
  created () {
    $(window).resize(() => {
        $(".form").width($("#chat").width())
    });
    $('div').on('DOMSubtreeModified propertychange', () => {      
      $(".form").width($("#chat").width())
    });
    $("html").on('click', (e) => {
      if($(window).width() <= 900){
        if(e.target.closest('#fix_bar') != null){
          this.$store.dispatch('switchDrawer', true)
        }
        else{
          this.$store.dispatch('switchDrawer', false)
        }
      }
    });        
  },
  mounted() {
    // fixedされたformの幅を調整するため、DOM描画後にも処理する。
    this.$nextTick(()=> {
      $('div').on('DOMSubtreeModified propertychange', () => {
        $(".form").width($("#chat").width())
      });
    })
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    drawer () {
      return this.$store.getters.drawer
    }
  },
  methods: {
    // ログアウト処理
    doLogout() {
      Firebase.logout()
    },
    switchDrawer () { 
      this.$store.dispatch('switchDrawer')
    }
  },
}
</script>

<style scoped>
.v-application a {
  margin-left: 20px;
  color: white;
  text-decoration: none;
}
</style>
